<template>
  <div class="container row big-box" id="footer">
    <div class="container section-text">
      <span class="title">Contact Us</span>
    </div>
    <div class="container column section-medsos">
      <div class="container row medsos max-width">
        <div class="icon-box">
          <a href="https://www.instagram.com/pofasilkomui/" target="_blank">
            <img
              src="../assets/logo-instagram.png"
              alt="Instagram Logo"
              class="icon"
            />
          </a>
        </div>
        <div class="text-box">
          <a href="https://www.instagram.com/pofasilkomui/" target="_blank">
            <span class="footer-txt">@pofasilkomui</span>
          </a>
        </div>
      </div>
      <div class="container row medsos max-width">
        <div class="icon-box">
          <a href="https://twitter.com/POFasilkomUI" target="_blank">
            <img
              src="../assets/logo-twitter.png"
              alt="Twitter Logo"
              class="icon"
            />
          </a>
        </div>
        <div class="text-box">
          <a href="https://twitter.com/POFasilkomUI" target="_blank">
            <span class="footer-txt">@POFasilkomUI</span>
          </a>
        </div>
      </div>
    </div>
    <div class="container column section-medsos">
      <div class="container row medsos max-width">
        <dic class="icon-box">
          <a href="https://line.me/R/ti/p/@rqi6185h" target="_blank">
            <img src="../assets/logo-line.png" alt="Line Logo" class="icon" />
          </a>
        </dic>
        <div class="text-box">
          <a href="https://line.me/R/ti/p/@rqi6185h" target="_blank">
            <span class="footer-txt">@rqi6185h</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
#footer {
  height: 40vh;
  background-color: #28587c;
  color: #f4f2f5;
  left: 0;
  bottom: 0;
}

.footer-txt {
  font-size: 40px;
  color: #f4f2f5;
}

.section-text {
  width: 35%;
}

.section-medsos {
  width: 30%;
}

.icon {
  width: 4vw;
  height: auto;
}

.icon-box {
  width: 25%;
}

.text-box {
  width: 75%;
  display: flex;
  justify-content: flex-start;
}

.medsos {
  margin: 2vh 1vw;
}

@media screen and (max-width: 1024px) {
  #footer {
    flex-direction: column;
  }

  .section-text {
    width: 80%;
    justify-content: flex-start;
    margin-bottom: 5px;
  }

  .section-medsos {
    width: 80%;
    justify-content: flex-start;
  }

  .icon-box {
    width: 20%;
  }

  .text-box {
    width: 80%;
  }

  .footer-txt {
    font-size: 1.4em;
  }

  .medsos {
    margin: 1vh 0;
  }
}

@media screen and (max-width: 500px) {
  .footer-txt {
    font-size: 4vw;
  }

  .icon {
    width: 7vw;
  }
}
</style>
